import React from "react";
import { Link } from "react-router-dom";
import businessBanner from "../../assets/business-loan-banner.jpg";
import "./LoanProduct.css";

const BusinessLoan = () => {
  return (
    <main className="loan-page">
      <section className="loan-hero" style={{ backgroundImage: `url(${businessBanner})` }}>
        <div className="loan-hero-inner cb-rise">
          <h1>Fuel growth with the right business loan partner</h1>
          <p>
            Core Bankers connects entrepreneurs with RBI-registered banks and NBFCs for working capital,
            expansion, and equipment finance. We guide — we do not lend.
          </p>
          <Link to="/eligibility" className="cb-btn">
            Check Eligibility
          </Link>
        </div>
      </section>

      <div className="loan-content">
        <section className="loan-section">
          <h2>Why choose Core Bankers</h2>
          <ul>
            <li>Access to multiple lenders for business loans</li>
            <li>No processing fees from our side</li>
            <li>Options for MSMEs, growing firms, and established enterprises</li>
            <li>Support with documentation and lender coordination</li>
            <li>Faster follow-through through our DSA network</li>
          </ul>
        </section>

        <section className="loan-section">
          <h2>Eligibility criteria</h2>
          <ul>
            <li>Business vintage of at least 1 year (preferred)</li>
            <li>Minimum turnover as per lender policy</li>
            <li>Valid GST, PAN, and business registration</li>
            <li>Sound repayment history or credit score</li>
            <li>Indian ownership and operational address</li>
          </ul>
        </section>

        <section className="loan-section">
          <h2>Documents required</h2>
          <ul>
            <li>PAN and Aadhaar of proprietor / partners / directors</li>
            <li>Business registration certificate</li>
            <li>Bank statements (last 6–12 months)</li>
            <li>GST returns / ITRs / financials</li>
            <li>Address proof and business proof</li>
          </ul>
        </section>

        <section className="loan-section">
          <h2>How it works</h2>
          <ol>
            <li>Submit your business loan enquiry</li>
            <li>We assess your profile and documents</li>
            <li>Lenders are matched based on eligibility</li>
            <li>Loan is disbursed directly by the lender</li>
          </ol>
        </section>

        <section className="loan-cta">
          <h2>Fund the next stage of your business</h2>
          <p>From working capital to expansion — we help you shortlist the right lending partner.</p>
          <Link to="/contact" className="cb-btn">
            Talk to us
          </Link>
        </section>
      </div>
    </main>
  );
};

export default BusinessLoan;
